import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-office-doc-list',
  templateUrl: './office-doc-list.component.html',
  styleUrls: ['./office-doc-list.component.scss'],
  standalone: false
})
export class OfficeDocListComponent implements OnInit {
  tokenDetails: any;
  selectedEngagementData: any;

  ngOnInit() {
    this.selectedEngagementData = JSON.parse(localStorage.getItem('userDetails'));
  }
}
